import React, { Component } from 'react'
import { Error } from 'react-form-error'

import Modal from 'react-modal';
import LoadingOverlay from 'react-loading-overlay';

import TableLists from './components/table';

import configs from '../../configs/config';
import axios from 'axios';
import Swal from 'sweetalert2'

export default class index extends Component {

    constructor() {
        super();
        this.state = {
            isuploading: false,
            errors: [],
            data:[],
            name:'',
        }
        this.getData();
    }

    getData = () => {
        axios.get(`${configs.URL_API_BASE}/emailLists/getEmailLists`, {})
            .then(res => {
                if (res.data.status === 200) {
                    console.log(res.data);
                    let auxData = res.data.results;
                    auxData.forEach((item) => {
                        item.id = item.emailListId;
                    })
                    this.setState({ data: auxData });
                    console.log(res.data.results);
                }
            });
    }
    delete = (id) => {
        axios.post(`${configs.URL_API_BASE}/emailLists/${id}/delete`)
            .then(res => {
                console.log(res);
                if (parseInt(res.data.status) === 200) {
                    this.getData();
                    Swal.fire('Eliminado!', 'Elemento eliminado correctamente.', 'success');
                } else {
                    Swal.fire('Error!', 'Contacte al desarrollador.', 'warning');
                }
            }).catch(err => {
                console.log(err);
                Swal.fire('Error!', 'Contacte al desarrollador.', 'warning');
            });
    }
    
    onInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    onSubmit = (e) => {
        e.preventDefault();
        if (this.state.name=='') return false;
        const formData = new FormData();
        formData.append('name', this.state.name);

        let url = ``;
        this.setState({ isuploading: true });
        url = `${configs.URL_API_BASE}/emailLists/createEmailList`;
        axios.post(url, formData, this.state.config).then((response) => {
            this.setState({ isuploading: false });
            if (parseInt(response.data.status) == 200) {
                this.props.history.push(`/emailLists/${response.data.results}`);
                //redireccionalo editar la campaña
            } else {
                console.log("fail");
            }
            this.closeModal();
        });
        e.target.reset();
    }

    handleOpenEdit = record => {
        this.props.history.push(`/emailLists/${record.id}`);
    }

    openModal = () => {
        this.setState({
            modalIsOpen: true,
            name: '',
        });
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    }

    render() {
        return (
            <>

                <div className="air__utils__heading d-flex justify-content-between align-self-center">
                    <h2>Listas de Correo</h2>

                    <a className="btn btn-primary d-flex justify-content-between align-self-center" href="#" onClick={this.openModal}>
                        <span>Nueva Lista&nbsp;</span>
                        <span><i className="fa fa-plus-circle" aria-hidden="true"></i></span>
                    </a>
                </div>
                <div className="row my-4">
                    <div className="col-12">
                        {
                            <TableLists handleOpenEdit={this.handleOpenEdit} delete={this.delete} data={this.state.data}></TableLists>
                        }
                    </div>
                </div>
            
                <Modal
                    appElement={document.getElementById("root")}
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    className="Modal"
                    contentLabel="Crear Lista de Correos">
                    <form onSubmit={this.onSubmit}>
                        <div className="modal-dialog">
                            <LoadingOverlay
                                active={this.state.isuploading}
                                spinner
                                text='Subiendo el contenido...'
                            >
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">{this.state.isEdit ? "Editar Lista" : "Crear Lista"}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row content-modal-mobile my-0 my-lg-4">
                                            <div className="col-12">
                                                <div className="form-row my-3">
                                                    
                                                    <div className="col-12 my-3">
                                                        <label>Nombre de la lista<span
                                                            className="text-red">*</span></label>
                                                        <input name="name" autoFocus={true} type="text" value={this.state.name} className="form-control" onChange={this.onInputChange} required />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-danger btn-lg" type="button" onClick={this.closeModal}>CANCELAR</button>
                                        <button className="btn btn-success btn-lg" type="submit">CONTINUAR</button>
                                    </div>
                                </div>
                            </LoadingOverlay>
                        </div>
                    </form>
                </Modal>


            </>
        )
    }
}
